import { config } from '@biketravel/config';

export const eventGpx = (id: number): string => `${config.EVENT_ENDPOINT}/event/gpx/${id}`;